import React, {Fragment, useEffect, useState, useCallback} from "react";
import Prev from "../../assets/image/icon_prev.svg";
import RightArrow from "../../assets/image/icon_right_sm.svg";
import Suffle from "../../assets/image/icon_shuffle.svg";
import Relay from "../../assets/image/icon_play_outline.svg";
import ViewIcon from "../../assets/image/icon_eye.svg";
import Split from "../../assets/image/split.svg";
import useFetch from "@common/hooks/fetch/useFetch";
import {
  getAdicPlayList,
  getAdicPlayListAd,
  removeAdicPlayList,
  removeAdicPlayListAd
} from "@common/services/restapi/mypage";
import {Link, useHistory, useParams} from "react-router-dom";
import {getAdDetailView} from "@common/services/restapi/ad";
import SmallCardHorizontal from "../set/SmallCardHorizontal";
import {Moments} from "@common/utils/date/moments";
import Delete from "../../assets/image/icon_trash.svg";
import {useAsyncFn} from "react-use";
import {LazyLoadImage} from "react-lazy-load-image-component";
import {Modal} from "react-bootstrap";
import BtnMedium from "../component/BtnMedium";
import Checkbox from "../component/Checkbox";
import {convertPath} from "@common/utils/path/linkPath";

function PlaylistDetailView () {

  const { userId, playlistId } = useParams();

  const {data: adicPlayList} = useFetch(() => getAdicPlayList({userId: userId, id: Number(playlistId)}), [], []);
  const {data: adicPlayListAd, refetch} = useFetch(() => getAdicPlayListAd({playlistId: playlistId}), [], []);

  // 플레이리스트 삭제
  const [removePlaylist, handleRemovePlaylist] = useAsyncFn(async(reqBody) => {
    if (!removePlaylist.loading) {
      await removeAdicPlayList(reqBody);
      await refetch();
    }
    setDeletePlaylist(false);
  });

  const [deletePlaylist, setDeletePlaylist] = useState(false)

  const history = useHistory();

  const handleGoBack = useCallback(() => {
    history.goBack();
  },[]);

  const [removePlaylistAd, handleRemovePlaylistAd] = useAsyncFn(async(reqBody) => {
    if (!removePlaylistAd.loading) {
      await removeAdicPlayListAd(reqBody);

      await refetch();
    }
  });

  return (
    <>
      <div className="common-header--top">
        <a className="prev-btn" onClick={handleGoBack}>
          <img src={Prev} alt=""/>
        </a>
        <h3 className="header-title">
          {adicPlayList.map((eachPlaylist) =>
            <>
              {eachPlaylist.id === Number(playlistId) && eachPlaylist.title}
            </>
          )}
        </h3>
      </div>

      <section className="common-body--list">
        {
          adicPlayListAd && adicPlayListAd.length > 0 &&
          <div className="row-box">
            <h4 className="headline"></h4>
            <a href={convertPath(`/mypage/playlist/${playlistId}/application`)} className="detail-view">
              <span>광고물 제공신청</span>
              <img src={RightArrow} alt=""/>
            </a>
          </div>
        }
        {/*<div className="btn-box">
          <button className="random">
            <img src={Suffle} alt=""/> 랜덤 재생
          </button>
          <button className="relay">
            <img src={Relay} alt=""/> 순차 재생
          </button>
        </div>*/}
        <div className="row-box playlist">
          <div className="video-count">광고 <span>{adicPlayListAd && adicPlayListAd.length}</span>개</div>
          <span className="all-delete" onClick={() => setDeletePlaylist(true)}>재생목록 삭제</span>
        </div>
        <div className="ad-list">
          {
            adicPlayListAd &&
              adicPlayListAd.map((eachData, i) => {
                    return (
                      <Fragment key={`ad-${eachData.ad.ukey}`}>
                        <div className="ad-box small-horizontal">
                          <div className="thumbnail-card-wrapper">
                            <a href={convertPath(`/ad/${eachData.category}/${eachData.ad.ukey}`)} className="thumbnail-card small-video">
                              <LazyLoadImage src={`${eachData.ad.thumbnail.replace('/l/', '/m/').replace("http:", "https:")}`}/>
                            </a>
                          </div>
                          <div className="ad-info has-delete">
                            <a href={convertPath(`/ad/${eachData.category}/${eachData.ad.ukey}`)} className="left-box">
                              <h4 className="title">{eachData.ad.title}</h4>
                              <h5 className="company">{eachData.ad.brand}</h5>
                              <div className="row-box">
                                {

                                  eachData.ad.rcount !== 0 &&
                                  <>
                                    <div className="view-count">
                                      <img src={ViewIcon} alt=""/>
                                      <span>{eachData.ad.rcount}</span>
                                    </div>
                                    <img src={Split} alt=""/>
                                  </>
                                }
                                <div className="created-date">{Moments.Format(eachData.ad.wdate, 'yyyy.MM.DD')}</div>
                              </div>
                            </a>
                            <i className="delete-icon" onClick={() => handleRemovePlaylistAd({id: eachData.id})}><img src={Delete}/></i>
                          </div>
                        </div>
                      </Fragment>
                    )
                  }
                )
          }
        </div>
      </section>
      <Modal show={deletePlaylist} dialogClassName="confirm-modal">
        <Modal.Body>해당 재생목록을 삭제하시겠습니까?</Modal.Body>
        <Modal.Footer>
          <BtnMedium type="button" color="black" text="취소" onClick={() => setDeletePlaylist(false)}/>
          <Link to={`/mypage`} className={`btn-medium blue`} onClick={() => handleRemovePlaylist({id: playlistId})}>확인</Link>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default PlaylistDetailView
